import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, LogOut, MyProfile, Notifications } from "../assets/svg";
import layoutContext from "./layoutContext";
import { useDispatch, useSelector } from "react-redux";
import { adminGetProfileData } from "../redux/auth/slice";
import ConfirmationModel from "../components/common/ConfirmationModel";
import { HambergerMenu } from "iconsax-react";
import { getNotification } from "../redux/notification/slice";
import NotificationModal from "../pages/notification/NotificationModal";

const Header = () => {
  const { isAsideOpen, setIsAsideOpen } = useContext(layoutContext);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch();
  const profileRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(adminGetProfileData());
    dispatch(
      getNotification({
        search: "",
        pageCount: 1,
        pageLimit: 10,
        sort_by: "",
        date_range: "",
      })
    );
  }, []);

  const { getProfileData, getNotificationData } = useSelector((store) => ({
    getProfileData: store?.authData?.adminGetProfileDataStatus?.data,
    getNotificationData:
      store?.notificationData?.getNotificationStatus?.data?.data,
  }));
  sessionStorage.setItem("companyData", JSON.stringify({ company: getProfileData?.company }));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const logOutClear = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <header className="sticky top-0 left-0 w-full z-[9]">
        <div className="shadow-md bg-headerDark h-16 w-full flex justify-between items-center px-4 md:px-6">
          <div className="flex items-center gap-2 cursor-pointer">
            <span onClick={() => setIsAsideOpen(!isAsideOpen)}>
              <div className="text-white flex items-center">
                <HambergerMenu
                  size="22"
                  color="#ffffff"
                  variant="Outline"
                  className="mr-2"
                />
                <p className="text-sm md:text-base font-semibold">
                  FBK ERP System
                </p>
              </div>
            </span>
          </div>
          <div className="flex items-center space-x-4">
            <div
              className="relative cursor-pointer"
              onClick={() => setOpen(true)}
            >
              <Notifications />
              {getNotificationData?.data?.filter((note) => note?.is_read === 0)
                ?.length > 0 && (
                <span className="absolute top-0 -right-1 translate-x-1 w-2 h-2 bg-notification rounded-full"></span>
              )}
              <span className="absolute top-0 right-0 translate-x-1 w-1.5 h-1.5 bg-secondary_light rounded-full"></span>
            </div>
            <div className="cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
              <Avatar />
            </div>
          </div>
        </div>

        {/* Profile Dropdown */}
        {isOpen && (
          <div className="fixed inset-0 flex justify-end z-50 px-4 mt-2">
            <div
              ref={profileRef}
              className="bg-white rounded-2xl shadow-xl w-11/12 sm:w-[280px] xs:[140px] top-[70px] absolute right-4"
            >
              <div className="px-4 py-3">
                <div className="pb-3 flex items-start">
                  <div className="ml-2">
                    <p className="font-poppins text-sm md:text-base font-medium text-black">
                      {getProfileData?.full_name}
                    </p>
                    <p className="font-poppins text-xs md:text-sm text-textSecondary">
                      {getProfileData?.email}
                    </p>
                  </div>
                </div>
                <div className="pb-3 flex items-start">
                  <div className="ml-2">
                    <p className="font-poppins text-sm md:text-base font-medium text-black">
                      {getProfileData?.company?.name || '-'}
                    </p>
                    <p className="font-poppins text-xs md:text-sm text-textSecondary">
                    {getProfileData?.company?.uen || '-'}
                    </p>
                  </div>
                </div>
                <div className="pb-3 flex items-start">
                  <div className="ml-2">
                    <p className="font-poppins text-sm md:text-base font-medium text-black">
                      Company Recurring Status
                    </p>
                    <p
                      className={`font-poppins text-xs md:text-sm ${
                        getProfileData?.company_recurring_status === "active"
                          ? "text-green-800"
                          : "text-red"
                      }`}
                    >
                      {getProfileData?.company_recurring_status}
                    </p>
                  </div>
                </div>
              </div>

              <hr className="border-lightgrey" />

              <div>
                <button
                  className="hover:bg-lightgrey w-full text-left px-4 py-2"
                  onClick={() => {
                    navigate("/profile");
                    setIsOpen(false);
                  }}
                >
                  <div className="flex items-center">
                    <MyProfile />
                    <p className="ml-4 text-sm md:text-base font-poppins">
                      My Profile
                    </p>
                  </div>
                </button>
                <button
                  className="hover:bg-lightgrey w-full text-left px-4 py-2"
                  onClick={() => setIsModalVisible(true)}
                >
                  <div className="flex items-center">
                    <LogOut />
                    <p className="ml-4 text-sm md:text-base font-poppins">
                      Logout
                    </p>
                  </div>
                </button>
              </div>
            </div>
          </div>
        )}
      </header>

      {/* Logout Confirmation Modal */}
      {isModalVisible && (
        <ConfirmationModel
          onConfirm={logOutClear}
          confirmText="Logout"
          onClose={() => setIsModalVisible(false)}
        />
      )}
      {open && <NotificationModal onClose={() => setOpen(false)} />}
    </>
  );
};

export default Header;
